import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { Course } from '../../core/models';

@Component({
    templateUrl: 'standalone-link.component.html',
    styleUrls: ['standalone-link.component.css']
})
export class StandaloneLinkComponent implements OnInit {
    public courses: Course[] = [];

    constructor(
        private route: ActivatedRoute
    ) {}

    public ngOnInit(): void {
        this.route.data.subscribe((params: Params) => {
            this.courses = params.courses;
        });
    }
}